import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingPane } from '../components';
import { useLazyFetch } from '@/utils';
import { AuthRoutes } from '@/model/Routes';

type OAuthState = {
  subdomain?: string;
  nonce?: string;
};

/**
 * View that the user is redirected to before we complete the Slack App OAuth flow.
 */
export function SlackAppOAuthCallback() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  if (code === null) {
    throw new Error('invalid oauth callback');
  }

  const givenState = searchParams.get('state');
  if (givenState === null) {
    throw new Error('invalid oauth callback');
  }
  const state: OAuthState = JSON.parse(decodeURIComponent(givenState));
  if (state.subdomain === undefined) {
    throw new Error('invalid oauth callback');
  }

  searchParams.set('code', code);
  searchParams.set('subdomain', state.subdomain);
  const prefix = '/auth/slackapp/exchange';
  const redirectRoute = AuthRoutes.SLACKAPP_OAUTH_SUCCESS;
  const [{ response: exchangeResponse, error: exchangeError }, exchange] = useLazyFetch(
    `${prefix}?${searchParams.toString()}`
  );
  if (exchangeError !== undefined) {
    throw exchangeError;
  }

  useEffect(() => {
    if (code !== null) {
      exchange();
    }
  }, [code, exchange]);

  useEffect(() => {
    if (exchangeResponse !== undefined) {
      navigate(redirectRoute, { replace: true });
    }
  }, [exchangeResponse, navigate, redirectRoute]);

  return <LoadingPane text="Logging In" />;
}
